export default "__VITE_ASSET__CwKlokZH__"